module.exports = __webpack_public_path__ + "static/media/img6.a558fcb4.jpg";